function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as a } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as l } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: o , size: c = 24  } = _param, r = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const t = s(), e = o !== null && o !== void 0 ? o : t ? l.colors.inverse : l.colors.neutralHigh;
    return /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, r), {
        children: /* @__PURE__ */ a("path", {
            fill: e,
            d: "M17.069 7.064c2.252-.639 3.96.347 4.588 2.63.305 1.126.232 2.148-.224 2.944-.448.812-1.27 1.406-2.373 1.72a3.874 3.874 0 01-1.447.11 8.625 8.625 0 00-.163-.015c.568.387 1.073.82 1.392 1.3v.003c1.308 1.974.938 3.947-.992 5.277-.762.527-1.524.787-2.246.787-1.107 0-2.126-.608-2.92-1.795-.304-.457-.509-1.06-.652-1.703-.143.65-.347 1.257-.655 1.72-.644.966-1.46 1.568-2.359 1.742a2.821 2.821 0 01-.554.053c-.734 0-1.505-.269-2.255-.793-.947-.65-1.538-1.479-1.709-2.392-.17-.913.078-1.905.72-2.874.32-.482.826-.919 1.398-1.305l-.105.01c-.168.017-.338.035-.5.035-.39 0-.76-.04-1.087-.135-2.247-.636-3.213-2.386-2.588-4.675.308-1.123.893-1.96 1.689-2.417.798-.457 1.8-.53 2.902-.213.65.187 1.322.636 1.955 1.18-.359-.794-.608-1.603-.605-2.312 0-2.372 1.395-3.79 3.728-3.79h.003c2.33.009 3.717 1.434 3.709 3.81 0 .694-.25 1.49-.605 2.271.635-.543 1.308-.988 1.955-1.173zm-2.171-1.095c.008-1.908-1.02-2.964-2.89-2.972-1.875 0-2.908 1.05-2.908 2.958-.006.896.568 2.282 1.582 3.843a2.98 2.98 0 01.586-.166l.086-.016c.202-.034.415-.056.645-.056a4.066 4.066 0 01.745.072 2.83 2.83 0 01.559.156l.004.001c1.028-1.577 1.59-2.927 1.59-3.82zm5.826 6.274c.345-.622.392-1.403.143-2.32-.504-1.834-1.773-2.56-3.577-2.05-.835.238-1.938 1.126-3.132 2.513.02.024.04.052.06.08l.038.054a1.789 1.789 0 01.19.291 3.039 3.039 0 01.177.393 3.468 3.468 0 01.14.61A4.254 4.254 0 0114.775 13c-.002.006-.002.012-.002.019l-.001.018c1.784.585 3.224.776 4.073.532.904-.258 1.535-.703 1.88-1.325zm-2.555 3.995c-.515-.77-1.829-1.614-3.63-2.348-.012.028-.026.055-.04.082a.482.482 0 00-.027.05.231.231 0 00-.018.035c-.006.012-.011.024-.018.035a2.384 2.384 0 01-.18.271c-.007.014-.017.024-.027.035l-.015.016a2.167 2.167 0 01-.534.47c-.012.008-.025.018-.04.026a2.2 2.2 0 01-.361.176c-.022.01-.045.017-.068.024l-.03.01a3.717 3.717 0 01-.34.095l-.083.017a4.108 4.108 0 00-.07.014l-.018.004a1.377 1.377 0 01-.097.018c-.006 1.972.28 3.524.795 4.297 1.054 1.577 2.485 1.86 4.028.787 1.55-1.067 1.824-2.53.773-4.114zm-9.294 4.736c.69-.134 1.306-.602 1.83-1.392.515-.773.8-2.328.8-4.297a.645.645 0 01-.066-.012.908.908 0 00-.06-.01 1.487 1.487 0 01-.113-.02l-.018-.003a3.263 3.263 0 01-.454-.12 2.305 2.305 0 01-.384-.174l-.018-.012a2.477 2.477 0 01-.363-.265 2.556 2.556 0 01-.193-.196l-.025-.028a2.062 2.062 0 01-.21-.294l-.015-.027a2.19 2.19 0 01-.1-.186c-1.781.723-3.076 1.56-3.58 2.32-.524.789-.725 1.545-.594 2.246.132.7.591 1.324 1.365 1.86.77.537 1.51.736 2.198.61zm-3.725-7.39c.857.245 2.297.054 4.067-.543-.003-.014-.003-.033-.003-.047a4.383 4.383 0 01.02-1.247c.006-.039.016-.076.025-.114l.02-.082a2.427 2.427 0 01.196-.6 2.634 2.634 0 01.216-.372c.025-.038.05-.075.078-.109a.5.5 0 00.024-.035.36.36 0 01.03-.04C8.648 9.03 7.524 8.122 6.704 7.886a3.911 3.911 0 00-1.073-.165c-.448 0-.852.1-1.202.303-.61.35-1.048.994-1.3 1.913-.501 1.837.216 3.134 2.02 3.647zm6.874.892c.026 0 .052.001.076-.003 1.03-.042 1.585-.434 1.798-1.23l.001-.004a.01.01 0 00.002-.004l.001-.013.001-.012c.06-.216.087-.477.087-.774 0-.795-.218-1.358-.647-1.678-.008-.008-.1-.07-.112-.075-.305-.19-.72-.286-1.232-.286-.507 0-.928.098-1.241.294a.983.983 0 00-.118.07c-.42.325-.633.888-.633 1.673 0 .294.028.557.087.787.238.843.829 1.232 1.823 1.255h.107z"
        })
    }));
}, v = i;
export { v as default };
